<template>
  <div>
    <CChartBar :datasets="dataSet" :options="options" :labels="label" />
  </div>
</template>

<script>
// import { CChartLine } from "@coreui/vue-chartjs";
import { CChartBar } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "OrderChart",
  components: {
    CChartBar,
  },
  props: {
    dataSet: {
      type: [Array, Object],
      default: () => [],
    },
    label: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: "IDR",
    },
  },
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        responsive: true,
        height: 250,
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: true,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                callback: (value, index, values) => {
                  return `${this.currency} ${this.formatPrice(value)}`;
                },
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (raw, data) => {
              return ` IDR ${this.formatPrice(raw.value)}`;
            },
          },
        },
        height: {
          type: Number,
          default: 500,
        },
      },
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
